<div class="tabs flex flex-row gap-[12px]">
  <ng-container *ngFor="let diagnosticTab of diagnosticsOverlayTabs$ | async">
    <div
      *ngIf="diagnosticTab.active"
      class="tab"
      [attr.data-at-diagnostic-tab-btn]="diagnosticTab.type"
      gtm="onSelectDiagnosticTab"
      gtmAction="Diagnostics Overlay"
      gtmCategory="Select diagnostic tab"
      [class.selected]="diagnosticTab.type === activeDiagnosticOverlay"
      (click)="onTabSelect(diagnosticTab.type)"
    >
      {{ diagnosticTab.title | translate }}
    </div>
  </ng-container>
</div>
